import type { EntityState } from '@reduxjs/toolkit';

import type RootState from 'app-components/utils/redux-store/rootState';

import type { TaskInstance } from './taskSchemas';

export const TASKS_REDUCER_KEY = 'tasksStore';
export type TASKS_REDUCER_KEY = typeof TASKS_REDUCER_KEY;

export type TaskCollectionStatus = 'loading' | 'ready' | 'error';

/** Shared service task collection. Surface membership is a selector concern. */
export type TasksState = EntityState<TaskInstance, string> & {
  error: string | null;
  fetchInvalidated: boolean;
  isLoading: boolean;
  loadPending: boolean;
  writeError: string | null;
};

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [TASKS_REDUCER_KEY]: TasksState;
  }
}

export type TasksRootState = Partial<Pick<RootState, typeof TASKS_REDUCER_KEY>>;
